// extracted by mini-css-extract-plugin
export default {"wrapLoader":"Loader_wrapLoader__DAh-a","modal":"Loader_modal__Let8Q"};